/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Address_StateInputs */

const en_clients_field_address_state = /** @type {(inputs: Clients_Field_Address_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State (UF)`)
};

const pt_br2_clients_field_address_state = /** @type {(inputs: Clients_Field_Address_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UF`)
};

/**
* | output |
* | --- |
* | "State (UF)" |
*
* @param {Clients_Field_Address_StateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_address_state = /** @type {((inputs?: Clients_Field_Address_StateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Address_StateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_address_state(inputs)
	return pt_br2_clients_field_address_state(inputs)
});